import { render, staticRenderFns } from "./CenterMain.vue?vue&type=template&id=48a9b9a4&scoped=true&"
import script from "./CenterMain.vue?vue&type=script&lang=js&"
export * from "./CenterMain.vue?vue&type=script&lang=js&"
import style0 from "./CenterMain.vue?vue&type=style&index=0&id=48a9b9a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9b9a4",
  null
  
)

export default component.exports